import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IConsole } from '../../Interfaces/IConsole';
import { ConsoleService } from '../../services/console-service';
import { TranslateService } from '../../../../../core/services/translate-service';

@Component({
  selector: 'console-detail',
  templateUrl: 'console-detail.html',
})
export class ConsoleDetail {
  formGroup: FormGroup;
  loading = false;
  list: any[] = [
    { Id: 1, Name: "Nombre 1" },
    { Id: 2, Name: "Nombre 2" },
    { Id: 3, Name: "Nombre 3" }
  ];


  constructor(
    private dialogRef: MatDialogRef<ConsoleDetail>,
    @Inject(MAT_DIALOG_DATA) public data: IConsole,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private consoleService: ConsoleService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      id: [data.id == null ? 0 : data.id],
      name: [data.name, Validators.required],
    });
  }
  //button save for add/edit
  Save() {
    if (this.formGroup.valid) {
      this.loading = true;
      if (this.formGroup.controls.id.value == 0) {
        this.consoleService.createConsole(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            this.loading = false;
            if (result.success) { this.Alert(); this.dialogRef.close(true); }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; }
        );
      }
      else {
        this.consoleService.updateConsole(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            this.loading = false;
            if (result.data) { this.Alert(); this.dialogRef.close(true); }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; }
        );
      }
    }
  }


  Close() {
    this.dialogRef.close(false);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: 'Complete',
      shown: true
    });

  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
  }
}
